import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCropCyclePeriodFilter } from 'src/app/core/models/period-selector/newCropCyclePeriodFilter';
import { NewCropCyclePeriodSelectorItem } from './base/new-crop-cycle-period-selector-item';
import moment from 'moment';
import { NewPeriodSelectorConfiguration } from 'src/app/core/models/period-selector/newPeriodSelectorConfiguration';


export class CropToDatePeriodSelectorItem extends NewCropCyclePeriodSelectorItem {
    interval = NewPeriodSelectorInterval.CropToDate;
    hasNavigation = false;

    constructor(name: string) {
        super(name);
    }

    isVisible = (config: NewPeriodSelectorConfiguration) => {
        if (config.visibleItems.find(i => i === NewPeriodSelectorInterval.CropToDate)) {
            if (config.cropCycles) {
                const singleCropCycle = config.cropCycles.length === 1
                    ? config.cropCycles[0]
                    : null;
                if (singleCropCycle) {
                    return moment().startOf('day').toDate() >= moment(singleCropCycle.startDate).startOf('day').toDate();
                }
            }
            return true;
        }
        return false;
    }

    getPeriodFilter = () => {
        const periodFilter = new NewCropCyclePeriodFilter();
        periodFilter.periodInterval = NewPeriodSelectorInterval.CropToDate;
        return periodFilter;
    }
}